<template>
    <slot name="form-purchase" v-bind="this"></slot>

    <alert-success
        v-if="showAlert"
        :title="alertData.title"
        :message="alertData.message"
        :html-content="alertData.htmlContent"
        :confirm-button-text="alertData.confirmButtonText"
        :style-button="alertData.styleButton"
        :icon="alertData.icon"
        :redirect="alertData.redirect"
        :new-tab="alertData.newTab"
    ></alert-success>


</template>

<script>

import FormValidator from "lib/form-validator.mjs";


export default {
    
    props: {
        cartPayment: { type: String, required: true },
        csrfToken: { type: String, required: true },
        logoEnfa: { type: String, required: true },
        confirmBtn: { type: String, required: true },
        cartReload: { type: String, required: true },
        successMessage: { type: String, required: true },
        errorMessageAlert: { type: String, required: true },
        confirmationText: { type: String, required: true }
    },
    data() {
        return {
            formValidator: new FormValidator({
                po: {
                    required: true,
                    type: 'string',
                    min: 3,
                    max: 30,
                }
            }, {
                po: ''
            }),

            po: '',
            submitLock: true,
            showAlert: false,
            alertData: {
                title: "",
                message: "",
                htmlContent: "",
                confirmButtonText: "",
                styleButton: "",
                icon: "",
                redirect: "",
                newTab: "",
            },

            errors: {
                po: { init: 1 }
            }
        }
    },
    watch: {
        po(val) {
            this.hideError('po');
            this.formValidator.setValue('po', val).then(
                () => {
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('po', error);
                    this.evaluateButtonStatus();
                }
            );
        },
    },
    methods: {
        hideError(name) {
            this.errors[name] = {};
        },
        showError(name, error) {
            this.errors[name] = {};
            this.errors[name][error] = true;
        },
        evaluateButtonStatus() {
            for( let error in this.errors ){
                if( Object.keys( this.errors[ error ] ).length > 0 ){
                    this.submitLock = true;
                    return;
                }
            }
            this.submitLock = false;
        },
        handleSubmit(e) {
            e.preventDefault();

            this.$emit('wait', true)


            const formData = new FormData();
            formData.append('po', this.po);
            formData.append('_token', this.csrfToken);

            fetch(this.cartPayment, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                return response.json().then(data => {

                    
                    if([1, 2, 3, 4, 5].includes(data.error)) {


                        this.alertData = {
                            title: this.errorMessageAlert,
                            confirmButtonText: this.confirmBtn,
                            styleButton: "btn btn-primary",
                            icon: this.logoEnfa,
                            redirect: this.cartReload
                        }

                        this.showAlert = true;

                    }

                    if(!response.ok) {
                        throw data;
                    }
                    return data;
                })
            })
            .then(data => {


                if(data.error === 0) {
                    
                    this.alertData = {
                        title: this.successMessage,
                        htmlContent: `<a href="${data.url}" target="_blank">${this.confirmationText}</a>`,
                        confirmButtonText: this.confirmBtn,
                        styleButton: "btn btn-primary",
                        icon: this.logoEnfa,
                        redirect: this.cartReload,
                        newTab: data.url
                    }

                    this.showAlert = true;
                }
                

            })
            .catch(error => {
                console.log(error.message)
                this.$emit('wait', false)
            })
            

        }
    },
}
</script>
